export enum AccountNavItemType {
  addressBook,
  creditCards,
  favorites,
  giftCards,
  memberRewards,
  nonLoyaltyMember,
  myAccount,
  myOrders,
  myProfile,
  signOut
}
